$(document).on('turbolinks:load', function() {
    //会社の保険加入状況出し分け
    if ($('select[id="office_company_classification"]').length > 0){
        office_company_classification_view();
        $('select[id="office_company_classification"]').change(function(){
            office_company_classification_view();
        });
    }
    function office_company_classification_view() {
        if ($('select[id="office_company_classification"] option:selected').val() == "only_roudou") {
            $('.employment_insurance_number').removeClass("d-none");
            $('.pension_mark').addClass("d-none");
            $('#office_pension_mark').val("");
            $('.pension_number').addClass("d-none");
            $('#office_pension_number').val("");
            $('.join_health_insurance').addClass("d-none");
            $('select[id="office_join_health_insurance"] option[value=""]').attr("selected", true);
            $('.join_health_insurance_name').addClass("d-none");
            $('#office_join_health_insurance_name').val("");
        } else if ($('#office_company_classification option:selected').val() == "only_syakai") {
            $('.employment_insurance_number').addClass("d-none");
            $('#office_employment_insurance_number').val("");
            $('.pension_mark').removeClass("d-none");
            $('.pension_number').removeClass("d-none");
            $('.join_health_insurance').addClass("d-none");
            $('.join_health_insurance_name').addClass("d-none");
        } else if ($('#office_company_classification option:selected').val() == "roudou_syakai") {
            $('.employment_insurance_number').removeClass("d-none");
            $('.pension_mark').removeClass("d-none");
            $('.pension_number').removeClass("d-none");
            $('.join_health_insurance').removeClass("d-none");
            $('.join_health_insurance_name').removeClass("d-none");
        } else {
            $('.employment_insurance_number').addClass("d-none");
            $('#office_employment_insurance_number').val("");
            $('.pension_mark').addClass("d-none");
            $('#office_pension_mark').val("");
            $('.pension_number').addClass("d-none");
            $('#office_pension_number').val("");
            $('.join_health_insurance').addClass("d-none");
            $('select[id="office_join_health_insurance"] option[value=""]').attr("selected", true);
            $('.join_health_insurance_name').addClass("d-none");
            $('#office_join_health_insurance_name').val("");
            $('.join_health_insurance_name').addClass("d-none");
            $('#office_join_health_insurance_name').val("");
        }
    }
    //紹介者出し分け
    if ($('select[id="office_introducer"]').length > 0){
        introducer_view();
        $('select[id="office_introducer"]').change(function(){
            introducer_view();
        });
    }
    function introducer_view() {
        if ($('select[id="office_introducer"] option:selected').val() == "from_tax_accountant") {
            $('.introducer_other').addClass("d-none");
            $('#office_introducer_other').val("");
            $('.introducer_name').removeClass("d-none");
            $('.introducer_phone_number').removeClass("d-none");
            $('.billing_email').removeClass("d-none");
            $('.billing_name').removeClass("d-none");
        } else if ($('#office_introducer option:selected').val() == "from_other") {
            $('.introducer_other').removeClass("d-none");
            $('.introducer_name').addClass("d-none");
            $('#office_introducer_name').val("");
            $('.introducer_phone_number').addClass("d-none");
            $('#office_introducer_phone_number').val("");
            $('.billing_email').addClass("d-none");
            $('#office_billing_email').val("");
            $('.billing_name').addClass("d-none");
            $('#office_billing_name').val("");
        } else {
            $('.introducer_name').addClass("d-none");
            $('#office_introducer_other').val("");
            $('.introducer_phone_number').addClass("d-none");
            $('.billing_email').addClass("d-none");
            $('.billing_name').addClass("d-none");
            $('#office_introducer_name').val("");
            $('.introducer_other').addClass("d-none");
            $('#office_introducer_phone_number').val("");
            $('#office_billing_email').val("");
            $('#office_billing_name').val("");
        }
    }
    //雇用保険被保険者番号出し分け
    if ($('select[id="employee_insurance_number_classification"]').length > 0){
        insurance_number_view();
        $('select[id="employee_insurance_number_classification"]').change(function(){
            insurance_number_view();
        });
    }
    function insurance_number_view() {
        if ($('select[id="employee_insurance_number_classification"] option:selected').val() == "insurance_number_have") {
            $('.insurance_number').removeClass("d-none");
            $('.former_job_company_name').addClass("d-none");
            $('#employee_former_job_company_name').val("");
        } else if ($('#employee_insurance_number_classification option:selected').val() == "insurance_number_maybe") {
            $('.insurance_number').addClass("d-none");
            $('#employee_insurance_number').val("");
            $('.former_job_company_name').removeClass("d-none");
        } else {
            $('.insurance_number').addClass("d-none");
            $('.former_job_company_name').addClass("d-none");
        }
    }
    //外国籍出し分け
    if ($('select[id$="_nationality"]').length > 0){
        nationality_view();
        $('select[id$="_nationality"]').change(function(){
            nationality_view();
        });
    }
    function nationality_view() {
        if ($('select[id$="_nationality"] option:selected').val() == "nationality_have") {
            $('.nationality_file').removeClass("d-none");
            $('.nationality_name').removeClass("d-none");
            $('.nationality_name_kana').removeClass("d-none");
        } else {
            $('.nationality_file').addClass("d-none");
            $('input[id$="_nationality_file"]').val("");
            $('.nationality_name').addClass("d-none");
            $('input[id$="_nationality_name"]').val("");
            $('.nationality_name_kana').addClass("d-none");
            $('input[id$="_nationality_name_kana"]').val("");
        }
    }
    //住まい出し分け
    if ($('select[id$="_cohabitation"]').length > 0){
        address_view();
        $('select[id$="_cohabitation"]').change(function(){
            address_view();
        });
    }
    function address_view() {
        if ($('select[id$="_cohabitation"] option:selected').val() == "cohabitation_no") {
            $('.zip_code').removeClass("d-none");
            $('.prefectures').removeClass("d-none");
            $('.address1').removeClass("d-none");
            $('.address2').removeClass("d-none");
            $('.address3').removeClass("d-none");
            $('.address1_kana').removeClass("d-none");
            $('.address2_kana').removeClass("d-none");
            $('.address3_kana').removeClass("d-none");
        } else {
            $('.zip_code').addClass("d-none");
            $('input[id="zip_code_3"]').val("");
            $('input[id="zip_code_4"]').val("");
            $('.prefectures').addClass("d-none");
            $('select[id="address0"] option[value=""]').attr("selected", true);
            $('.address1').addClass("d-none");
            $('input[id="address1"]').val("");
            $('.address2').addClass("d-none");
            $('input[id="address2"]').val("");
            $('.address3').addClass("d-none");
            $('input[id="address3"]').val("");
            $('.address1_kana').addClass("d-none");
            $('input[id="address1_kana"]').val("");
            $('.address2_kana').addClass("d-none");
            $('input[id="address2_kana"]').val("");
            $('.address3_kana').addClass("d-none");
            $('input[id="address3_kana"]').val("");
        }
    }
    //学年出し分け
    if ($('select[id$="_work"]').length > 0){
        school_year_view();
        $('select[id$="_work"]').change(function(){
            school_year_view();
        });
    }
    function school_year_view() {
        if ($('select[id$="_work"] option:selected').val() == "student") {
            $('.school_year').removeClass("d-none");
        } else {
            $('.school_year').addClass("d-none");
            $('input[id$="_school_year"]').val("");
        }
    }
    //被扶養者になった理由出し分け
    if ($('select[id$="_suport_start_reason"]').length > 0){
        suport_start_reason_view();
        $('select[id$="_suport_start_reason"]').change(function(){
            suport_start_reason_view();
        });
    }
    function suport_start_reason_view() {
        if ($('select[id$="suport_start_reason"] option:selected').val() == "reason_other") {
            $('.suport_start_reason_other').removeClass("d-none");
        } else {
            $('.suport_start_reason_other').addClass("d-none");
            $('input[id$="_suport_start_reason_other"]').val("");
        }
    }
    //契約社員出し分け
    if ($('select[id$="_employment_status"]').length > 0){
        contract_view();
        $('select[id$="_employment_status"]').change(function(){
            contract_view();
        });
    }
    function contract_view() {
        if ($('select[id$="_employment_status"] option:selected').val() == "contract") {
            $('.contract_period').removeClass("d-none");
            $('.contract_renewal').removeClass("d-none");
        } else {
            $('.contract_period').addClass("d-none");
            $('select[id$="_contract_period"] option[value=""]').attr("selected", true);
            $('.contract_renewal').addClass("d-none");
            $('select[id$="_contract_renewal"] option[value=""]').attr("selected", true);
        }
    }
    //契約期間出し分け
    if ($('select[id$="_contract_period"]').length > 0){
        contract_period_view();
        $('select[id$="_contract_period"]').change(function(){
            contract_period_view();
        });
    }
    function contract_period_view() {
        if ($('select[id$="_contract_period"] option:selected').val() == "contract_period_yes") {
            $('.contract_period_date').removeClass("d-none");
        } else {
            $('.contract_period_date').addClass("d-none");
            $('input[id$="_contract_period_start"]').val("");
            $('input[id$="_contract_period_end"]').val("");
        }
    }
    //前職出し分け
    if ($('select[id$="_former_job"]').length > 0){
        former_job_view();
        $('select[id$="_former_job"]').change(function(){
            former_job_view();
        });
    }
    function former_job_view() {
        if ($('select[id$="_former_job"] option:selected').val() == "former_job_yes") {
            $('.former_job_company_name').removeClass("d-none");
        } else {
            $('.former_job_company_name').addClass("d-none");
            $('input[id$="_former_job_company_name"]').val("");
        }
    }
    //退職理由出し分け
    if ($('select[id$="_retirement_reason"]').length > 0){
        retirement_reason_view();
        $('select[id$="_retirement_reason"]').change(function(){
            retirement_reason_view();
        });
    }
    function retirement_reason_view() {
        if ($('select[id$="_retirement_reason"] option:selected').val() == "approach") {
            $('.retirement_reason_detail').removeClass("d-none");
            $('.retirement_reason_detail_more').removeClass("d-none");
            $('.retirement_reason_detail_other').addClass("d-none");
            $('input[id$="_retirement_reason_other"]').val("");
        } else if ($('select[id$="_retirement_reason"] option:selected').val() == "reason_other") {
            $('.retirement_reason_detail').addClass("d-none");
            $('.retirement_reason_detail_more').addClass("d-none");
            $('.retirement_reason_detail_other').removeClass("d-none");
            $('select[id$="_retirement_reason_detail"] option[value=""]').attr("selected", true);
            $('input[id$="_retirement_reason_detail_more"]').val("");
        } else {
            $('.retirement_reason_detail').addClass("d-none");
            $('.retirement_reason_detail_more').addClass("d-none");
            $('.retirement_reason_detail_other').addClass("d-none");
            $('select[id$="_retirement_reason_detail"] option[value=""]').attr("selected", true);
            $('input[id$="_retirement_reason_detail_more"]').val("");
            $('input[id$="_retirement_reason_other"]').val("");
        }
    }
    //離職票出し分け
    if ($('select[id$="_unemployment_slip"]').length > 0){
        unemployment_slip_view();
        $('select[id$="_unemployment_slip"]').change(function(){
            unemployment_slip_view();
        });
    }
    function unemployment_slip_view() {
        if ($('select[id$="_unemployment_slip"] option:selected').val() == "unemployment_slip_yes") {
            $('.payroll').removeClass("d-none");
            $('.attendance').removeClass("d-none");
        } else {
            $('.payroll').addClass("d-none");
            $('.attendance').addClass("d-none");
            $('input[id$="_payroll"]').val("");
            $('input[id$="_attendance"]').val("");
        }
    }
    //年度更新出し分け
    if ($('input[id$="_annual_renewal"]').length > 0){
        annual_renewal_view();
        $('input[id$="_annual_renewal"][type="checkbox"]').change(function(){
            annual_renewal_view();
        });
    }
    function annual_renewal_view() {
        if ($('input[id$="_annual_renewal"][type="checkbox"]').prop('checked')) {
            $('#annual_renewal_area').addClass("show");
        } else {
            $('#annual_renewal_area').removeClass("show");
            $('select[id$="_annual_renewal_industry"] option[value=""]').attr("selected", true);
        }
    }
    //算定基礎届出し分け
    if ($('input[id$="_base_amount"]').length > 0){
        base_amount_view();
        $('input[id$="_base_amount"][type="checkbox"]').change(function(){
            base_amount_view();
        });
    }
    function base_amount_view() {
        if ($('input[id$="_base_amount"][type="checkbox"]').prop('checked')) {
            $('#base_amount').addClass("show");
        } else {
            $('#base_amount').removeClass("show");
            $('select[id$="_health_insurance"] option[value=""]').attr("selected", true);
        }
    }
    //問い合わせページ-紹介者出し分け
    if ($('select[id="inquiry_introducer"]').length > 0){
        inquiry_introducer_view();
        $('select[id="inquiry_introducer"]').change(function(){
            inquiry_introducer_view();
        });
    }
    function inquiry_introducer_view() {
        if ($('select[id="inquiry_introducer"] option:selected').val() == "その他") {
            $('.inquiry_introducer_other').removeClass("d-none");
            $('.inquiry_introducer_name').addClass("d-none");
            $('#inquiry_introducer_name').val("");
        } else if ($('select[id="inquiry_introducer"] option:selected').val() == "税理士") {
            $('.inquiry_introducer_name').removeClass("d-none");
            $('.inquiry_introducer_other').addClass("d-none");
            $('#inquiry_introducer_other').val("");
        } else {
            $('.inquiry_introducer_other').addClass("d-none");
            $('.inquiry_introducer_name').addClass("d-none");
            $('#inquiry_introducer_other').val("");
            $('#inquiry_introducer_name').val("");
        }
    }

});


